var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1902 25.4582C13.8654 23.9367 10 19.3821 10 14C10 7.37258 15.861 2 23.0909 2C27.9364 2 32.167 4.41319 34.4305 8H37C41.9706 8 46 12.0294 46 17C46 21.9706 41.9706 26 37 26H22.2727C21.1899 26 20.1517 25.8088 19.1902 25.4582Z",
    fill: "#D9DBE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1994 36V44M28 38.3477L34.5265 42.1157M28 42.1159L34.5265 38.3478M9.16683 33.5996V46M4 36.0796L14.3337 43.5198M4 43.5204L14.3337 36.0801M19.1902 25.4582C13.8654 23.9367 10 19.3821 10 14C10 7.37258 15.861 2 23.0909 2C27.9364 2 32.167 4.41319 34.4305 8H37C41.9706 8 46 12.0294 46 17C46 21.9706 41.9706 26 37 26H22.2727C21.1899 26 20.1517 25.8088 19.1902 25.4582Z",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.c17deaf948c9c3ec2d1214e2c48b16db.svg";
export { ForwardRef as ReactComponent };